import { FunctionComponent } from 'react';
import clsx from 'clsx';

import { AchievementCircleVariant } from 'components/profile/achievements/Achievement';

export interface Props {
  className: string;
  level?: number;
  variant?: AchievementCircleVariant;
}

export const variantToClassnameModifier = {
  large: 'large',
  default: undefined,
};

const AchievementCircle: FunctionComponent<Props> = ({
  className,
  level,
  children,
  variant = 'default',
}) => {
  const circleClassname = clsx(
    'Achievement_container',
    variantToClassnameModifier[variant],
    className
  );
  const levelClassname = clsx('Achievement_level', variantToClassnameModifier[variant]);
  return (
    <>
      <div className={circleClassname}>
        <div className="AchievementsBar_achievement">{children}</div>
        {(level || 0) > 1 ? <div className={levelClassname}>{level}x</div> : undefined}
      </div>
    </>
  );
};

export default AchievementCircle;
